export default "__VITE_ASSET__DMc8UXZk__"